import slide1 from '../icons/CORAZON ESCUDO - FARMACOVIGILANCIA.gif';
import slide2 from '../icons/ICONO DE TOS.gif';
import slide3 from '../icons/llamada.png';

const farmacoSlides = [
  {
    title: 'Bienvenidos a<br />',
    bold: 'Farmacovigilancia',
    description: '',
    image: slide1,
  },
  {
    title: 'Síntomas',
    description:
      'Descripción detallada del evento adverso ocurrido, por favor describa: Qué le ocurrio, Cuándo comenzó, Si tomó algún otro medicamento o remedio, si se recuperó.',
    image: slide2,
  },
  {
    title: 'Atención <br />personalizada',
    description:
      'Tu tranquilidad es nuestra prioridad. Recibe asesoría profesional experta para tomar las mejores decisiones.',
    image: slide3,
  },
];

export default farmacoSlides;
